/**
 * Plain-language CRM sync resolution labels (ENR-4105).
 * Matches FormCrmSyncService CrmSyncResolution values.
 */
const CRM_RESOLUTION_LABELS: Record<
  string,
  { label: string; tip: string }
> = {
  created: {
    label: 'Created',
    tip: 'A new contact was created in your CRM for this submission.',
  },
  updated: {
    label: 'Updated',
    tip: 'An existing CRM contact matched by email and was updated, including the form tag.',
  },
  duplicate_recovered: {
    label: 'Matched existing',
    tip: 'Your CRM reported a duplicate contact. We recovered the existing contact and applied the form fields and tag.',
  },
  skipped: {
    label: 'Skipped',
    tip: 'CRM sync was turned off or intentionally skipped for this submission.',
  },
  failed: {
    label: 'Failed',
    tip: 'CRM sync failed. Check the error details and retry from this page.',
  },
};

export function formatCrmResolutionLabel(resolution?: string | null): string {
  if (!resolution) return '—';
  return CRM_RESOLUTION_LABELS[resolution]?.label ?? resolution;
}

export function getCrmResolutionTip(resolution?: string | null): string | null {
  if (!resolution) return null;
  return CRM_RESOLUTION_LABELS[resolution]?.tip ?? null;
}
